import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';

export const installmentPaymentReserveApprove = http.patch(
  createMockEndpoint('/shop/:id/reserved_split_payment/:reservedShopSplitPaymentInformationId/approve'),
  async () => {
    await delay(500);
    return HttpResponse.json(null, { status: 200 });
  },
);
